export const ACCOUNT_TAGS_SEARCH = "ACCOUNT_TAGS_SEARCH";
export const ACCOUNT_TAGS_SEARCH_RESPONSE = "ACCOUNT_TAGS_SEARCH_RESPONSE";

export const ACCOUNT_TAGS_SEARCH_PARENTS = "ACCOUNT_TAGS_SEARCH_PARENTS";
export const ACCOUNT_TAGS_SEARCH_PARENTS_RESPONSE = "ACCOUNT_TAGS_SEARCH_PARENTS_RESPONSE";

export const ACCOUNT_TAGS_SEARCH_CHILDREN = "ACCOUNT_TAGS_SEARCH_CHILDREN";
export const ACCOUNT_TAGS_SEARCH_CHILDREN_RESPONSE = "ACCOUNT_TAGS_SEARCH_CHILDREN_RESPONSE";